"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAttrFormatter = listAttrFormatter;
const index_js_1 = require("../../../errors/index.js");
const formatValuePath_js_1 = require("../../../schema/actions/utils/formatValuePath.js");
const isArray_js_1 = require("../../../utils/validation/isArray.js");
const attribute_js_1 = require("./attribute.js");
const utils_js_1 = require("./utils.js");
function* listAttrFormatter(attribute, rawValue, { attributes, valuePath = [], ...restOptions } = {}) {
    const { format = true, transform = true } = restOptions;
    if (!(0, isArray_js_1.isArray)(rawValue)) {
        const { type } = attribute;
        const path = (0, formatValuePath_js_1.formatValuePath)(valuePath);
        throw new index_js_1.DynamoDBToolboxError('formatter.invalidAttribute', {
            message: `Invalid attribute detected while formatting${path !== undefined ? `: '${path}'` : ''}. Should be a ${type}.`,
            path,
            payload: { received: rawValue, expected: type }
        });
    }
    // We don't need isProjected:
    // - Either whole list is projected and we already know => projectedAttributes undefined
    // - Either some elements are projected => childrenAttributes undefined
    // - Either projection is deep => childrenAttributes defined
    const { childrenAttributes } = (0, utils_js_1.matchProjection)(/\[\d+\]/, attributes);
    const formatters = rawValue.map((element, index) => (0, attribute_js_1.attrFormatter)(attribute.elements, element, {
        attributes: childrenAttributes,
        valuePath: [...valuePath, index],
        ...restOptions
    }));
    if (transform) {
        const transformedValue = formatters.map(formatter => formatter.next().value);
        if (format) {
            yield transformedValue;
        }
        else {
            return transformedValue;
        }
    }
    const formattedValue = formatters.map(formatter => formatter.next().value);
    return formattedValue;
}
